(function() {
  const modal = document.getElementById('offer-modal');
  const openBtn = document.getElementById('make-offer-btn');
  const closeBtn = document.querySelector('.close-modal');
  const form = modal?.querySelector('form');
  const statusMessage = document.getElementById('form-status-message');
  
  if (!openBtn || !modal) {
    console.warn('Make an Offer elements not found');
    return;
  }
  
  let isSubmitting = false;
  
  // Open modal
  openBtn.addEventListener('click', function(e) {
    e.preventDefault();
    modal.style.display = 'flex';
    document.body.style.overflow = 'auto'; // Page remains scrollable
    statusMessage.style.display = 'none'; // Hide previous messages
    
    const modalContent = document.querySelector('.offer-modal-content');
    if (modalContent) {
      modalContent.scrollTop = 0;
    }
  });
  
  // Close modal
  closeBtn.addEventListener('click', function() {
    closeModal();
  });
  
  // Close modal when clicking outside
  modal.addEventListener('click', function(event) {
    if (event.target === modal) {
      closeModal();
    }
  });
  
  // Close modal on escape key
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && modal.style.display === 'flex') {
      closeModal();
    }
  });
  
  // Close modal function
  function closeModal() {
    modal.style.display = 'none';
    document.body.style.overflow = 'auto'; // Keep page scrollable
    isSubmitting = false;
    
    // Re-enable submit button
    const submitBtn = form?.querySelector('button[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Submit Offer';
    }
  }
  
  // Prevent multiple form submissions
  if (form) {
    form.addEventListener('submit', function(e) {
      if (isSubmitting) {
        e.preventDefault();
        return;
      }
      
      isSubmitting = true;
      
      // Disable submit button
      const submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';
      }
    });
  }
  
  // Check for success/error messages every 500ms
  let checkCount = 0;
  const messageChecker = setInterval(() => {
    checkCount++;
    
    // Check if form was submitted and page refreshed
    if (isSubmitting) {
      // Look for success message in Liquid render
      const successCheck = document.querySelector('#form-status-message.success');
      const errorCheck = document.querySelector('#form-status-message.error');
      
      if (successCheck || errorCheck) {
        clearInterval(messageChecker);
        
        // Keep message visible for 3 seconds then close
        setTimeout(() => {
          closeModal();
          
          // Reset form after close
          setTimeout(() => {
            if (form) {
              form.reset();
            }
            isSubmitting = false;
            checkCount = 0;
            
            // Re-enable button
            const submitBtn = form?.querySelector('button[type="submit"]');
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = 'Submit Offer';
            }
          }, 100);
        }, 3000);
      }
    }
    
    // Stop checking after 10 seconds (form didn't process)
    if (checkCount > 20) {
      clearInterval(messageChecker);
      isSubmitting = false;
      
      // Re-enable button
      const submitBtn = form?.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Submit Offer';
      }
    }
  }, 500);
})();
